import React, { useState } from 'react'
import { navigate } from 'gatsby'
import Link from '../Link'
import * as styles from './index.module.css'
import ChildNav from '../ChildNav'
import ChildNavPlain from '../ChildNavPlain'
import { dynamicSort, isSvgOrGif } from '../../utils'
import useWindowSize from '../../hooks/useWindowSize'
import Caret from './Caret'
import Li from './Li'
import { useIntl } from 'react-intl'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const NavLink = ({
  updateChildData,
  childLinks,
  defaultUrl,
  hoverHandler,
  label,
  inverted,
  hoverGradient,
  lowerNavLink,
  list,
  latestBlogPost,
  locale,
  links,
  ...rest
}) => {
  const { width } = useWindowSize()
  const intl = useIntl()
  const latestPost = intl.formatMessage({ id: 'blog.latestBlogPost' })
  const readNow = intl.formatMessage({ id: 'blog.readMore' })
  const isMobile = width <= 767
  const isTablet = width >= 767 && width <= 1199
  const [showChildNavs, setShowChildNavs] = useState(false)
  const childProps = { label, childLinks, hoverGradient }
  let navUrl = defaultUrl
    ? defaultUrl
    : childLinks[0].url.indexOf('talk-to-sales') !== -1
    ? childLinks[0].url
    : null

  const handleClick = (event) => {
    if ((isMobile || isTablet) === true) {
      if (childLinks.length > 1) {
        setShowChildNavs(!showChildNavs)
      }
    } else {
      navUrl && navigate((navUrl += navUrl.endsWith('/') ? '' : '/'))
    }
  }

  const getClass = (array, classA, classB) =>
    array
      .filter((e) => e.type !== 'LowerNavLink' && e.type !== 'BlogLink')
      .filter((e) => e.type === 'rich').length > 0
      ? classA
      : classB

  return !list ? (
    <>
      {!navUrl ? (
        <span className={inverted ? styles.invertedLink : ''} {...rest}>
          {label}
        </span>
      ) : (
        <Link
          to={(navUrl += navUrl.endsWith('/') ? '' : '/')}
          className={styles.link}
          {...rest}
        >
          <span className={inverted ? styles.invertedLink : ''}>{label}</span>
        </Link>
      )}
    </>
  ) : (
    <Li {...childProps}>
      <div
        className={[
          styles.parentLink,
          'hoverParentLink',
          inverted ? styles.invertedParent : '',
        ].join(' ')}
        onClick={childLinks.length > 1 ? handleClick : null}
      >
        {(isMobile || isTablet) && !inverted && (
          <span className={styles.caretContainer}>
            {childLinks.length > 1 && (
              <Caret
                className={styles.mobileCaretHolder}
                up={showChildNavs ? true : false}
                down={!showChildNavs ? true : false}
              />
            )}
          </span>
        )}

        {!navUrl ? (
          <span className={inverted ? styles.invertedLink : ''} {...rest}>
            {label}
          </span>
        ) : (
          <Link
            to={(navUrl += navUrl.endsWith('/') ? '' : '/')}
            className={styles.link}
            {...rest}
          >
            <span className={inverted ? styles.invertedLink : ''}>{label}</span>
          </Link>
        )}
      </div>

      {childLinks.length > 1 && (
        <div
          className={`${
            links
              ? getClass(
                  links[0].childLinks,
                  styles.childLinks,
                  styles.childLinksPlain
                )
              : getClass(childLinks, styles.childLinks, styles.childLinksPlain)
          } ${
            (isMobile || isTablet) && !showChildNavs
              ? styles.toggleChildLinks
              : ''
          }${!isMobile && !isTablet ? ' hoverChildLinks ' : ''}`}
        >
          <div
            className={[
              links
                ? getClass(
                    links[0].childLinks,
                    styles.childLinkContainer,
                    styles.childLinkPlainContainer
                  )
                : getClass(
                    childLinks,
                    styles.childLinkContainer,
                    styles.childLinkPlainContainer
                  ),
              links ? styles.childLinkGroupContainer : '',
            ].join(' ')}
          >
            {links
              ? links.map(
                  (
                    {
                      childLinks,
                      groupHeader,
                      groupHeaderImage,
                      groupHeaderUrl,
                    },
                    idx
                  ) => {
                    return (
                      <div className={styles.linkGroupContainer} key={idx}>
                        {groupHeader && (
                          <div className={styles.groupHeader}>
                            {groupHeaderImage && (
                              <div className={styles.groupHeaderImage}>
                                {isSvgOrGif(groupHeaderImage.file.url) ? (
                                  <div>
                                    {groupHeaderUrl ? (
                                      <Link to={groupHeaderUrl}>
                                        <img
                                          alt={groupHeaderImage.description}
                                          src={groupHeaderImage.file.url}
                                        />
                                      </Link>
                                    ) : (
                                      <img
                                        alt={groupHeaderImage.description}
                                        src={groupHeaderImage.file.url}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <div>
                                    {groupHeaderUrl ? (
                                      <Link to={groupHeaderUrl}>
                                        <GatsbyImage
                                          alt={groupHeaderImage.description}
                                          image={getImage(
                                            groupHeaderImage.gatsbyImageData
                                          )}
                                          objectFit="contain"
                                        />
                                      </Link>
                                    ) : (
                                      <GatsbyImage
                                        alt={groupHeaderImage.description}
                                        image={getImage(
                                          groupHeaderImage.gatsbyImageData
                                        )}
                                        objectFit="contain"
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                            {groupHeaderUrl ? (
                              <Link to={groupHeaderUrl}>{groupHeader}</Link>
                            ) : (
                              <span>{groupHeader}</span>
                            )}
                          </div>
                        )}
                        <div className={styles.linkGroup}>
                          {childLinks &&
                            childLinks
                              .sort(dynamicSort('order'))
                              .filter(
                                (e) =>
                                  e.type !== 'LowerNavLink' &&
                                  e.type !== 'BlogLink'
                              )
                              .map((childLink, idx) =>
                                childLink.type === 'rich' ? (
                                  <ChildNav
                                    {...childLink}
                                    locale={locale}
                                    key={idx}
                                  />
                                ) : (
                                  <ChildNavPlain
                                    className={styles.childLinkGroup}
                                    {...childLink}
                                    locale={locale}
                                    key={idx}
                                  />
                                )
                              )}
                        </div>
                      </div>
                    )
                  }
                )
              : childLinks &&
                childLinks
                  .sort(dynamicSort('order'))
                  .filter(
                    (e) => e.type !== 'LowerNavLink' && e.type !== 'BlogLink'
                  )
                  .map((childLink, idx) =>
                    childLink.type === 'rich' ? (
                      <ChildNav locale={locale} {...childLink} key={idx} />
                    ) : (
                      <ChildNavPlain locale={locale} {...childLink} key={idx} />
                    )
                  )}
          </div>

          {links &&
            links.map(({ childLinks }) => {
              return childLinks
                .filter((e) => e.type === 'LowerNavLink')
                .map((childLink, idx) => {
                  return (
                    <div className={styles.lowerLink} key={idx}>
                      <Link to={childLink.url}>
                        {' '}
                        <div>
                          <p>{childLink.label} </p>
                          <svg
                            width="7"
                            height="12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M4.667 6L0 1.2 1.167 0 7 6l-5.833 6L0 10.8 4.667 6z"
                            />
                          </svg>
                        </div>
                        <span>{childLink.subtitle}</span>
                      </Link>
                    </div>
                  )
                })
            })}

          {childLinks
            .filter((e) => e.type === 'LowerNavLink')
            .map((childLink, idx) => {
              return (
                <div className={styles.lowerLink} key={idx}>
                  <Link to={childLink.url}>
                    {' '}
                    <div>
                      <p>{childLink.label} </p>
                      <svg
                        width="7"
                        height="12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.667 6L0 1.2 1.167 0 7 6l-5.833 6L0 10.8 4.667 6z"
                        />
                      </svg>
                    </div>
                    <span>{childLink.subtitle}</span>
                  </Link>
                </div>
              )
            })}

          {childLinks.filter((e) => e.type === 'BlogLink').length > 0 && (
            <div className={styles.blogLinkContainer}>
              <Link
                to={`${locale === 'en-us' ? '/blog/' : `/${locale}/blog/`}${
                  latestBlogPost.slug
                }`}
              >
                <span className={styles.blogLink}>{latestPost}</span>
                <p>{latestBlogPost.title}</p>
                <span className={styles.blogLinkReadNow}>{readNow}</span>
              </Link>
            </div>
          )}

          {links &&
            links.map(
              ({ childLinks }) =>
                childLinks.filter((e) => e.type === 'BlogLink').length > 0 && (
                  <div className={styles.blogLinkContainer}>
                    <Link
                      to={`${
                        locale === 'en-us' ? '/blog/' : `/${locale}/blog/`
                      }${latestBlogPost.slug}`}
                    >
                      <span className={styles.blogLink}>{latestPost}</span>
                      <p>{latestBlogPost.title}</p>
                      <span className={styles.blogLinkReadNow}>{readNow}</span>
                    </Link>
                  </div>
                )
            )}
        </div>
      )}
    </Li>
  )
}

NavLink.defaultProps = {
  list: true,
}

export default NavLink
